import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const API = process.env.REACT_APP_BACKEND_URL;

export const SlipDiscountDialog = ({ slip, headers, onClose, onSaved }) => {
  const [type, setType] = useState(slip.discount_type || "percent");
  const [value, setValue] = useState(slip.discount_value || "");
  const subtotal = slip.subtotal ?? (slip.items || []).reduce((s, i) => s + (i.total || 0), 0);
  const v = parseFloat(value) || 0;
  const discount = type === "percent" ? subtotal * Math.min(v, 100) / 100 : Math.min(v, subtotal);

  const save = async (discountType, discountValue) => {
    try {
      await axios.put(`${API}/api/admin/delivery-slips/${slip.id}/discount`,
        { discount_type: discountType, discount_value: discountValue }, { headers });
      toast.success(discountType ? "Remise appliquée" : "Remise retirée");
      onSaved();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erreur lors de la remise");
    }
  };

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="max-w-sm" data-testid="slip-discount-dialog">
        <DialogHeader>
          <DialogTitle>Remise - {slip.slip_number}</DialogTitle>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-2">
          <Button type="button" variant={type === "percent" ? "default" : "outline"} onClick={() => setType("percent")} data-testid="discount-type-percent">En %</Button>
          <Button type="button" variant={type === "amount" ? "default" : "outline"} onClick={() => setType("amount")} data-testid="discount-type-amount">En €</Button>
        </div>
        <Input type="number" step="0.01" min="0" value={value} onChange={(e) => setValue(e.target.value)}
          placeholder={type === "percent" ? "Ex : 10" : "Ex : 5"} data-testid="discount-value-input" />
        <div className="text-sm space-y-1 bg-slate-50 p-3 rounded" data-testid="discount-preview">
          <p className="flex justify-between"><span>Sous-total</span><span>{subtotal.toFixed(2)}€</span></p>
          <p className="flex justify-between text-green-700"><span>Remise</span><span>-{discount.toFixed(2)}€</span></p>
          <p className="flex justify-between font-bold"><span>Total</span><span>{(subtotal - discount).toFixed(2)}€</span></p>
        </div>
        <div className="flex gap-2 justify-end">
          {slip.discount_type && (
            <Button type="button" variant="ghost" className="text-red-600" onClick={() => save(null, 0)} data-testid="discount-remove-btn">Retirer</Button>
          )}
          <Button type="button" className="bg-pink-500 hover:bg-pink-600" disabled={v <= 0} onClick={() => save(type, v)} data-testid="discount-save-btn">Appliquer</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export const SlipDiscountLine = ({ slip }) => {
  if (!slip.discount_amount) return null;
  const label = slip.discount_type === "percent" ? ` (${slip.discount_value}%)` : "";
  return <span className="text-xs text-green-700" data-testid="slip-discount-line">Remise{label} : -{slip.discount_amount.toFixed(2)}€</span>;
};
